var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { title: "Por Creación" } },
    [
      _vm.selectedYear
        ? _c(
            "b-link",
            {
              staticClass: "small mb-1 d-block",
              on: { click: _vm.backToYears }
            },
            [_vm._v(" ← Volver a años ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "pie-text text-center" }, [
        _c("h2", { staticClass: "font-weight-bolder" }, [
          _vm._v(" " + _vm._s(_vm.total || 0) + " ")
        ]),
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v(_vm._s(_vm.selectedYear || "Total"))
        ])
      ]),
      _c("app-echart-doughnut", {
        attrs: { series: _vm.series, "show-legend": _vm.showLegend },
        on: { click: _vm.handleClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }